import { render, staticRenderFns } from "./HorizontalLayout.vue?vue&type=template&id=37fec884&"
import script from "./HorizontalLayout.vue?vue&type=script&lang=ts&"
export * from "./HorizontalLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports